import React from 'react';

import { createRoot } from 'react-dom/client';

import Logger from '../../services/Logger';
import { PREPARE_ACTIONS } from '../../helpers/shopify/prepareActions';
import PrepareMediaForShopifyDialog from './PrepareMediaForShopifyDialog';

/**
 * Shows Prepare media for Shopify dialog.
 * @param {{ assets: Array<{ _id: string, name?: string }> }} params
 * @returns {Promise<'proceed'|'cancel'|'assetCopy'>}
 */
export default function showPrepareMediaForShopifyDialog({ assets }) {
  Logger.log('UI', 'ShowPrepareMediaForShopifyDialog', {
    assetsCount: (assets || []).length,
  });

  return new Promise((resolve) => {
    const dialogRoot = document.getElementById('dialogRoot');
    const wrapperDialog = document.createElement('div');
    wrapperDialog.id = 'wrapperPrepareMediaForShopifyDialog';
    wrapperDialog.className = 'wrapperDialogOverlay';
    dialogRoot.appendChild(wrapperDialog);

    const root = createRoot(wrapperDialog);

    const cleanup = (action) => {
      Logger.log('User', 'PrepareMediaForShopifyDialogClosed', { action });
      try {
        root.unmount();
      } catch { /* ignore */ }
      if (wrapperDialog.parentNode) {
        dialogRoot.removeChild(wrapperDialog);
      }
      resolve(action);
    };

    root.render(
      <PrepareMediaForShopifyDialog
        assets={assets}
        onPrepare={() => cleanup(PREPARE_ACTIONS.PROCEED)}
        onAssetCopy={() => cleanup(PREPARE_ACTIONS.ASSET_COPY)}
        onCancel={() => cleanup(PREPARE_ACTIONS.CANCEL)}
      />,
    );
  });
}
